import React from 'react';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { parseContent } from 'client/data/cms/content';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { getMeta, getMetaRobots } from 'site-modules/shared/utils/seo-helper';
import { getAboutArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getAboutArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { AboutArticle } from './about-article';

export const getPageOptions = (splat, articleId) => ({
  name: `other_about_us_${articleId.replace(/-/g, '_')}`,
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);
    const articlePath = getAboutArticleContentPath(splat, articleId);

    preloader.resolve(`content["${articlePath}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}"]`, CmsModel);

      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }

      return preloader.load();
    });
  },
  seo: state => {
    const modelState = getModelState(state);
    const articlePath = getAboutArticleContentPath(splat, articleId);
    const content = parseContent(modelState.get(`content["${articlePath}"]`, CmsModel));
    const robots = getMetaRobots(content);

    return {
      ...getMeta(content),
      ...robots,
      title: content.title,
      jsonld: [getBreadcrumbSchema(getAboutArticleBreadcrumbs({ splat, articleId, title: content.title }))],
    };
  },
  component: props => <AboutArticle {...props} articleId={articleId} splat={splat} />,
  decorator: EdmundsCpaNoAdhesionDecorator,
});

const pages = [];
export default ({ splat = '', articleId }) => {
  const pageKey = `${splat}|${articleId}`;
  pages[pageKey] = pages[pageKey] || pageDefinition(getPageOptions(splat, articleId));
  return pages[pageKey];
};
